<template>
    <div class="flex w-full min-h-screen">
        <NavigationBar/>
        <!-- Смена тарифа на транзакции -->
        <div class="w-full flex flex-col lg:flex-row gap-4 lg:gap-[24px] justify-center mt-4 lg:mt-[48px] px-4 lg:px-6">
            <div
                class="flex flex-col gap-4 lg:gap-[24px] items-center w-full lg:w-auto lg:min-w-[550px]"
                v-show="currentStep.index === 1"
            >
                <SwitchRate v-model:status="switchStatus" class="w-full"/>
                <div
                    v-if="switchStatus === 'subs'"
                    class="flex flex-col gap-4 lg:gap-[24px] items-center w-full"
                >
                    <RateBlock v-model:subs="subs" v-model:selected-sub="selectedSub" class="w-full"/>
                    <DurationBlock v-model:durations="duration" v-model:selected-duration="selectedDuration" class="w-full"/>
                </div>
                <div
                    v-if="switchStatus === 'transactions'"
                    class="flex flex-col gap-4 lg:gap-[24px] items-center w-full"
                >
                    <div v-if="!isTransactionsPricingAvailable" class="lg:max-w-[550px] w-full rounded-[16px] border-[#e1e1e1] border bg-[#f2f2f2] font-bold py-8 px-4">
                        <div class="font-bold">Вы используете бесплатный тариф, поэтому докупить транзакции нельзя.</div>
                        <div class="font-bold">Перейдите на платную подписку, чтобы получить больше возможностей.</div>
                    </div>
                    <TransactionsBlock
                        v-else
                        :price="price"
                        :price-per-transaction="pricePerTransaction"
                        v-model:transactions-list="transactionsList"
                        v-model:transactions-quantity="transactionsQuantity"
                        class="w-full"
                    />

                </div>
            </div>
            <div
                class="flex flex-col gap-4 lg:gap-[24px] items-center w-full lg:w-auto lg:min-w-[550px]"
                v-show="currentStep.index === 2"
            >
                <SelectPaymentType @click="handlePayment"/>
                <UserPaymentData v-model="userPaymentInfo" ref="userPaymentDataRef" />
            </div>
            <div class="flex flex-col gap-4 lg:gap-[24px] items-center w-full lg:w-auto">
                <OrderBlock
                    v-model:sub="selectedSub"
                    v-model:duration="selectedDuration"
                    v-model:price="price"
                    v-model:steps-quantity="stepsQuantity"
                    v-model:current-step="currentStep"
                    v-model:switch-status="switchStatus"
                    v-model:transactions="transactionsQuantity"
                    class="w-full lg:w-[300px]"
                    v-if="currentStep.index !== 3"
                />
                <div
                    class="flex justify-between w-full lg:w-[300px]"
                    v-if="currentStep.index === 1"
                >
                    <div class="w-[120px]">
                    </div>
                    <div class="w-[120px] flex justify-end">
                        <NextButton v-if="canGoNext" @click="nextStep" />
                    </div>

                </div>
                <div
                    class="flex justify-between w-full lg:w-[300px]"
                    v-if="currentStep.index === 2"
                >
                    <div class="w-[120px]">
                        <PreviousButton v-if="canGoPrev" @click="prevStep" />
                    </div>
                    <div class="w-[120px] flex justify-end">
                        <PaymentButton  @click="handlePayment" />
                    </div>

                </div>

            </div>

        </div>
    </div>
</template>

<script setup>
/* eslint-disable */

import NavigationBar from '@/components/NavigationBar.vue';
import { Api } from '@/service/api';
import {ref, onMounted, computed} from 'vue';
import {useRoute} from "vue-router";
import RateBlock from "@/pages/Subscriptions/RateBlock.vue";
import SwitchRate from "@/pages/Subscriptions/SwitchRate.vue";
import DurationBlock from "@/pages/Subscriptions/DurationBlock.vue";
import OrderBlock from "@/pages/Subscriptions/OrderBlock.vue";
import PreviousButton from "@/pages/Subscriptions/PreviousButton.vue";
import NextButton from "@/pages/Subscriptions/NextButton.vue";
import TransactionsBlock from "@/pages/Subscriptions/TransactionsBlock.vue";
import SelectPaymentType from "@/pages/Subscriptions/SelectPaymentType.vue";
import UserPaymentData from "@/pages/Subscriptions/UserPaymentData.vue";
import PaymentButton from "@/pages/Subscriptions/PaymentButton.vue";

import {createToaster} from "@meforma/vue-toaster";


const subs = ref([])
const duration = ref([])
const selectedSub = ref()
const selectedDuration = ref()
const user = ref()

const userPaymentInfo = ref({
    fullName: "",
    email: "",
})

const toaster = createToaster()

const userPaymentDataRef = ref(null)

const switchStatus = ref("subs")

const steps = ref([
    {type: 'selectOrder', index: 1},
    {type: 'selectPaymentType', index: 2},
])

const currentStep = ref(
    steps.value[0]
)

const stepsQuantity = 3

const transactionsList = ref([
    500, 1000, 1500, 2000
])

const pricePerTransaction = ref(1)

const transactionsQuantity = ref(transactionsList.value[0])




const price = computed(() => {
    if (switchStatus.value === 'subs') {
        if (selectedDuration.value?.discount === 0) {
            return selectedSub.value?.price_per_month * selectedDuration.value?.month_count
        }
        else {
            return Math.round((selectedSub.value?.price_per_month * selectedDuration.value?.month_count) * (100 - selectedDuration.value?.discount) / 100)
        }
    }
    else if (switchStatus.value === 'transactions') {
        return Math.round(transactionsQuantity.value * pricePerTransaction.value)
    }
    return 0
})


const isTransactionsPricingAvailable = computed(() => {
    return !user.value?.subscription?.plan?.is_base_plan
})


const route = useRoute()

onMounted(async () => {
    subs.value = await Api.getSubscriptionPlans()
    duration.value = await Api.getSubscriptionDurations()

    user.value = await Api.getUserMeInfo()

    pricePerTransaction.value = user.value.subscription.plan.price_per_transaction

    for (let i = 0; i < duration.value.length; i++) {
        duration.value[i].name = duration.value[i].month_count + " месяц"
        if (duration.value[i].month_count === 3){
            duration.value[i].name += "а"
        }
        else if (duration.value[i].month_count === 6 || duration.value[i].month_count === 12) {
            duration.value[i].name += "ев"
        }
    }

    switchStatus.value = route.query?.order_type?.toLowerCase() || 'subs'

    selectedSub.value = subs.value.find(item => item.name.toLowerCase() === route.query?.plan?.toLowerCase()) ?? subs.value[0]
    selectedDuration.value = duration.value.find(item => parseInt(item.month_count) === parseInt(route.query?.length || 0)) ?? duration.value[0]

})


const selectedPaymentMethod = ref('creditCard')


async function processPayment() {
    let url = ""
    let order_info = {}
    if (selectedPaymentMethod.value === 'creditCard') {
        if (switchStatus.value === 'subs') {
            order_info = await Api.getPaymentUrl(selectedSub.value, selectedDuration.value, userPaymentInfo.value)
        }
        else if (switchStatus.value === 'transactions') {
            order_info = await Api.getTransactionsPaymentUrl(transactionsQuantity.value, userPaymentInfo.value)

        }
        window.open(order_info.confirmation_url)
    }
    return order_info.order.id
}


function redirectToCreatedOrder(orderId) {
    return
}


const handlePayment = async () => {
    if (userPaymentDataRef.value.validate()) {
        const orderId = await processPayment()
        redirectToCreatedOrder(orderId)
    } else {
        toaster.error("Пожалуйста, заполните все обязательные поля")
    }
}


function selectTransactionsQuantity(transactions) {
    transactionsQuantity.value = transactions
}

const nextStep = () => {
    const currentIndex = steps.value.findIndex(step => step.type === currentStep.value.type)
    if (currentIndex < steps.value.length - 1) {
        currentStep.value = { ...steps.value[currentIndex + 1] }
    }
}

const prevStep = () => {
    const currentIndex = steps.value.findIndex(step => step.type === currentStep.value.type)
    if (currentIndex > 0) {
        currentStep.value = { ...steps.value[currentIndex - 1] }
    }
}

const canGoNext = computed(() => {
    const currentIndex = steps.value.findIndex(step => step.type === currentStep.value.type)
    return currentIndex < steps.value.length - 1
})

const canGoPrev = computed(() => {
    const currentIndex = steps.value.findIndex(step => step.type === currentStep.value.type)
    return currentIndex > 0
})


</script>